export const ABORT_SIGNAL_NAME = {
  resourcesControlContextFetchResponsibleEmployee: 'resourcesControlContext::FetchResponsibleEmployee',
  resourcesControlContextFetchEmployeeInformation: 'resourcesControlContext::FetchEmployeeInformation',
  resourcesControlContextFetchVehicleInformation: 'resourcesControlContext::FetchVehicleInformation',
};
